module.exports = __webpack_public_path__ + "img/pick3_blue.61abb44e.png";